import React from "react";

const AtHomePedicureTreatment = () => {
  return (
    <div className="blogHead-content">
      <h2>At-Home Pedicure Treatments for Dry and Cracked Heels</h2>
      <p>
        If visiting a salon isn’t an option, you can still pamper your feet at
        home with a DIY pedicure treatment. Here’s how:
      </p>
      <ul>
        <h4>Step-by-Step At-Home Pedicure:</h4>
        <li>
          {" "}
          <span> 1. Soak:</span>
          <p>
            Fill a basin with warm water and add a few drops of
            essential oil or a handful of Epsom salts. Soak your feet for 10-15
            minutes.
          </p>
        </li>
        <li>
          <span>2. Exfoliate:</span>
          <p>
             Use a foot scrub or pumice stone to gently remove dead
            skin from your heels.
          </p>
        </li>
        <li>
          <span> 3. Moisturize:</span>
          <p>
            Apply a thick layer of foot cream or petroleum jelly
            to your heels and cover with socks to lock in moisture.{" "}
          </p>
        </li>
        <li>
          <span>4. Nail Care:</span>
          <p>
             Trim and shape your nails as needed, finishing with a
            layer of nail polish if desired.
          </p>
        </li>
      </ul>
      <p>
        <span>Pro Tip:</span> For an extra boost of hydration, use a foot mask
        or wrap your feet in warm towels after applying moisturizer.
      </p>
    </div>
  );
};

export default AtHomePedicureTreatment;
